/**
 * The DSL definition input (LAR-1).
 *
 * Presentational: it owns no validation state and makes no request. The editor above it holds the
 * text and decides when to validate, which is what lets the same component serve creation and
 * editing without knowing which one it is in.
 *
 * **Both inputs, where Trade had one.** Its page accepted a `.clj` upload and nothing else — there
 * was no way to fix a typo without going back to your editor. Lab's first pass accepted a textarea
 * and nothing else, so an author with a strategy on disk had to paste it. Neither workflow is the
 * special case.
 *
 * **What changed: the textarea is no longer always on.** It was, and uploading a real Composer
 * export — thirty million characters on one line — put all of it in the DOM and hung the tab. The
 * mechanics of not doing that live in `DefinitionInput`, shared with the portfolio form, because
 * the hazard is the length of the text and not the language it is written in.
 */
import { DefinitionInput, type StoredDefinition } from './DefinitionInput';

interface Props {
  value: string;
  /** The definition is on the server and not in `value` — see `DefinitionInput` (#418). */
  stored?: StoredDefinition | null;
  onLoadStored?: () => Promise<unknown>;
  disabled?: boolean;
  onChange: (code: string) => void;
}

export function DslStrategyForm({ value, stored, onLoadStored, disabled, onChange }: Props) {
  return (
    <DefinitionInput
      id="strategy-dsl"
      label="Definition"
      accept=".txt,.clj,.edn,.json"
      uploadLabel="Upload DSL file"
      value={value}
      stored={stored}
      onLoadStored={onLoadStored}
      disabled={disabled}
      onChange={onChange}
      help={
        <>
          Composer DSL. The strategy's name, description and id are read out of the definition —
          validate to see what they resolve to.
        </>
      }
    />
  );
}
